import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

export default function FullScreenLoader({ open, message = "RERA verifying..." }) {
  return (
    <Backdrop
      open={open}
      sx={{ zIndex: (t) => t.zIndex.modal + 1, color: "#000", bgcolor: "rgba(255,255,255,0.9)" }}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <CircularProgress size={84} thickness={5} />
        <Typography sx={{ mt: 2, fontFamily: "Rubik, sans-serif", fontWeight: 600, fontSize: 20 }}>
          {message}
        </Typography>
      </div>
    </Backdrop>
  );
}